$(function () {
  activeNav();
  whiteLogo();
  video();
  author();
  reveal();
});

// function darkMode() {
//   $('.toggle-track').on('click', function () {
//     if (html.hasClass('dark-mode')) {
//       html.removeClass('dark-mode');
//       localStorage.setItem('alto_dark', false);
//     } else {
//       html.addClass('dark-mode');
//       localStorage.setItem('alto_dark', true);
//     }
//   });
// }

function whiteLogo() {
  if (typeof gh_white_logo != 'undefined') {
    const whiteImage =
      '<img class="logo-image white" src="' + gh_white_logo + '">';
    $('.logo').append(whiteImage);
  }
}

function video() {
  'use strict';
  $('.post-content').fitVids();
}

function author() {
  $('.author-name').on('click', function () {
    $(this).next('.author-social').toggleClass('enabled');
  });
}

function activeNav() {
  if (
    $('body.post-template').not('.tag-toitures').length ||
    $('body.tag-template').not('.tag-toitures').length
  ) {
    var blogTag = $('nav').find('a[href*="/blog"]');
    // blogTag.addClass('border-b-2 border-accent');
  } else if ($('body.post-template').hasClass('tag-toitures')) {
    var blogTag = $('nav').find('a[href*="/toitures"]');
    blogTag.addClass('border-b-2 border-accent');
  }
}

// --- Slider Clients ---
if ($('ul.marquee-content').length) {
  const root = document.documentElement;
  const marqueeElementsDisplayed = getComputedStyle(root).getPropertyValue(
    '--marquee-elements-displayed'
  );
  const marqueeContent = document.querySelector('ul.marquee-content');

  root.style.setProperty('--marquee-elements', marqueeContent.children.length);

  for (let i = 0; i < marqueeElementsDisplayed; i++) {
    marqueeContent.appendChild(marqueeContent.children[i].cloneNode(true));
  }
}

// Caroussel
if ($('.glider').length) {
  new Glider(document.querySelector('.glider'), {
    slidesToShow: 1,
    slidesToScroll: 1,
    scrollLock: true,
    draggable: true,
    arrows: {
      prev: '.glider-prev',
      next: '.glider-next',
    },
    responsive: [
      {
        // screens greater than >= 775px
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        // screens greater than >= 1024px
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
    ],
  });
}

function reveal() {
  const reveals = document.querySelectorAll('.reveal');

  for (i = 0; i < reveals.length; i++) {
    const windowHeight = window.innerHeight;
    const elementTop = reveals[i].getBoundingClientRect().top;
    const elementVisible = 150;
    if (elementTop < windowHeight - elementVisible) {
      reveals[i].classList.add('active');
    }
  }
}

window.addEventListener('scroll', reveal);

// --- Video ---
if ($('#vid').length) {
  player = videojs('vid', { restoreEl: true, controls: true });
  function handleVideoClick(value) {
    if (value) {
      player.play();
    } else {
      player.pause();
    }
  }
}

// --- Clients Logo ---
function exists(arr, search) {
  return arr.some((row) => row.includes(search));
}

const clientArray = [
  ['/assets/images/logo/agence-du-soleil.png', 'Agence du soleil'],
  ['/assets/images/logo/agence-peyrot.png', 'Agence Peyrot'],
  ['/assets/images/logo/azureva.png', 'Azureva'],
  ['/assets/images/logo/canet-en-roussillon.png', 'Canet-en-Roussillon'],
  ['/assets/images/logo/cic.png', 'CIC'],
  ['/assets/images/logo/credit-agricole.png', 'Crédit Agricole'],
  ['/assets/images/logo/foncia.png', 'Foncia'],
  ['/assets/images/logo/geodis.png', 'Geogis'],
  ['/assets/images/logo/le-boulou.png', 'Le Boulou'],
  ['/assets/images/logo/office-66.png', 'Office 66'],
  ['/assets/images/logo/pernod-ricard.png', 'Pernod Ricard'],
  ['/assets/images/logo/perpignan.png', 'Perpignan Méditerranée Métropole'],
  ['/assets/images/logo/port-vendres.png', 'Port-Vendres'],
  [
    '/assets/images/logo/saint-charles-international.png',
    'Saint-Charles International',
  ],
  ['/assets/images/logo/saint-cyprien.png', 'Saint-Cyprien'],
  ['/assets/images/logo/sncf.png', 'SNCF'],
  ['/assets/images/logo/vectalia.png', 'Vectalia'],
  ['/assets/images/logo/vinci.png', 'Vinci'],
];

const arrayFinal = [];
const clientNumber = 6;
const clientExist = !!document.getElementById('div-clients');

if (clientExist === true) {
  const divClients = document.getElementById('div-clients');
  for (let i = 0; i < clientNumber; i++) {
    const rand = clientArray[Math.floor(Math.random() * clientArray.length)];
    if (exists(arrayFinal, rand[0])) {
      i--;
      continue;
    }
    arrayFinal.push(rand);
    const newDiv = document.createElement('div');
    newDiv.setAttribute(
      'class',
      'col-span-1 flex justify-center bg-gray-50 div-client'
    );
    divClients.appendChild(newDiv);

    const newImg = document.createElement('img');
    newImg.setAttribute('class', 'logo');
    newImg.setAttribute('src', arrayFinal[arrayFinal.length - 1][0]);
    newImg.setAttribute('alt', arrayFinal[arrayFinal.length - 1][1]);
    newDiv.appendChild(newImg);
  }
}
